// extracted by mini-css-extract-plugin
export default {"amountCard":"AmountCard_amountCard__Ey2jh","title":"AmountCard_title__5MFtx","amount":"AmountCard_amount__7-DW+"};